<template>
  <div class="mx-5">
    <div
      v-for="(commentary, index) in preList"
      :key="problemId + 'post' + index"
      :class="{ 'mb-6': index !== preList.length - 1 }"
    >
      <CommentaryPanel
        :bindCommentary="bindCommentary"
        :commentary="commentary"
        :icon="'live_help'"
        :panelIndex="index"
        :selectedIndex="commentaryPageStatePresenter.preCommentarySelectedList.value[commentary.type] ?? 0"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted } from 'vue'

import CommentaryPanel from './children/CommentaryPanel.vue'

import { useCommentaryPageStatePresenter } from '@/presentation/composables/commentary/useCommentaryPageStatePresenter'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useProblemDescriptionPresenter } from '@/presentation/composables/problem/useProblemDescriptionPresenter'
import { useProblemStatePresenter } from '@/presentation/composables/problem/useProblemStatePresenter'

export default defineComponent({
  components: { CommentaryPanel },
  setup(props, ctx) {
    const commentaryPageStatePresenter = useCommentaryPageStatePresenter()
    const { displayLanguage, programLanguage } = useConfigStatePresenter()
    const { problemId } = useProblemStatePresenter()
    const problemDescriptionPresenter = useProblemDescriptionPresenter()

    const preList = computed(() =>
      problemDescriptionPresenter.problemDescription.value.commentaries.filter(
        (c: { pattern: string }) => c.pattern == 'pre'
      )
    )

    const bindCommentary = async (panelIndex: number, selectedIndex: number, value: string) => {
      const target = preList.value[panelIndex]
      commentaryPageStatePresenter.bindCommentary(
        displayLanguage.value,
        problemId.value,
        target.pattern,
        target.type,
        value,
        selectedIndex
      )
      wait5mMathJax()
    }

    const wait5mMathJax = () => {
      setTimeout(() => {
        // @ts-ignore
        // eslint-disable-next-line no-undef
        MathJax.typeset()
      }, 100)
    }

    onMounted(() => {
      commentaryPageStatePresenter.openCommentaryPage(
        programLanguage.value,
        displayLanguage.value,
        problemId.value,
        'pre',
        preList.value
      )
      wait5mMathJax()
    })

    return {
      preList,
      bindCommentary,
      commentaryPageStatePresenter,
      problemId
    }
  }
})
</script>

<style lang="postcss" scoped>
.slide-fade-enter-active {
  transition: all 0.8s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.4s ease-out;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
